export default "__VITE_ASSET__DKwSJIPc__"